import graphql from "babel-plugin-relay/macro";
import { useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { PatronBookingAffectedRateItemLineInner } from "./PatronBookingAffectedRateItemLineInner";
import {
  HoleCount,
  PatronBookingAffectedRateItemLineQuery,
} from "./__generated__/PatronBookingAffectedRateItemLineQuery.graphql";

type PatronBookingAffectedRateItemLineProps = {
  rateId: string;
  targetId: string;
  holeCount: HoleCount;
  durationMins: number;
  playerCount: number;
  slotTargetId: string;
  sourceBookingRateId: string;
};

export const PatronBookingAffectedRateItemLine = ({
  rateId,
  targetId,
  holeCount,
  durationMins,
  playerCount,
  slotTargetId,
  sourceBookingRateId,
}: PatronBookingAffectedRateItemLineProps) => {
  const [queryRef, loadQuery] =
    useQueryLoader<PatronBookingAffectedRateItemLineQuery>(
      PatronBookingAffectedRateItemLineQueryString
    );

  useEffect(() => {
    loadQuery({
      rateId,
      targetId,
      durationMins,
      playerCount,
      holeCount,
      slotTargetId,
      sourceBookingRateId,
    });
  }, [
    loadQuery,
    targetId,
    durationMins,
    playerCount,
    holeCount,
    slotTargetId,
    rateId,
    sourceBookingRateId,
  ]);

  return queryRef ? (
    <PatronBookingAffectedRateItemLineInner
      queryRef={queryRef}
      targetId={targetId}
    />
  ) : null;
};

export const PatronBookingAffectedRateItemLineQueryString = graphql`
  query PatronBookingAffectedRateItemLineQuery(
    $rateId: ID!
    $targetId: ID!
    $durationMins: Int!
    $playerCount: Int!
    $holeCount: HoleCount!
    $slotTargetId: ID!
    $sourceBookingRateId: ID!
  ) {
    newRate: node(id: $rateId) {
      __typename
      id
      ... on CustomerRate {
        name
      }
    }
    sourceRoundOrBooking: node(id: $targetId) {
      __typename
      ... on StandardBooking {
        id
        rate {
          name
          code
          appliesToMembershipType
        }
        startSlot {
          id
          slotRate(id: $sourceBookingRateId) {
            totalDurationPrice(
              duration: $durationMins
              playerCount: $playerCount
            )
            totalGolfPrice(holeCount: $holeCount)
          }
        }
      }
      id
      ... on Round {
        player {
          fullName
        }
        roundRate {
          totalGolfPrice(holeCount: $holeCount)
          totalDurationPrice(duration: $durationMins, playerCount: $playerCount)
          rate {
            name
          }
        }
      }
    }
    targetSlotForBookingPrice: node(id: $slotTargetId) {
      __typename
      ... on TimeSlot {
        id
        slotRate(id: $rateId) {
          rate {
            name
          }
          totalDurationPrice(duration: $durationMins, playerCount: $playerCount)
          totalGolfPrice(holeCount: $holeCount)
        }
      }
    }
  }
`;
